import type { Answer, Quiz } from '@efdigital/ll-addon-data';
import { quizAnswers } from '@efdigital/ll-admin-v2/utils/quiz-answers';
import Component from '@glimmer/component';

import type { EditingContext } from '../edit-context.gts';
import { EditQuizAvailability } from './edit-quiz-availability.gts';
import { EditQuizCategories } from './edit-quiz-categories.gts';
import { EditQuizCertificate } from './edit-quiz-certificate.gts';
import { EditQuizInput } from './edit-quiz-input.gts';
import { EditQuizOutput } from './edit-quiz-output.gts';
import { EditQuizQuestionsInput } from './edit-quiz-questions/input-editor.gts';
import { EditQuizQuestionsOutput } from './edit-quiz-questions/output-editor.gts';
import { EditQuizReporting } from './edit-quiz-reporting.gts';
import { EditQuizTotals } from './edit-quiz-totals.gts';
import type { View } from './quiz-edit-mode.gts';

function eq(a: string, b: string): boolean {
  return a === b;
}

export class QuizEditSidebar extends Component<{
  Args: {
    quiz: Quiz;
    answers: Answer;
    context: EditingContext;
    view: View;
    isolate: (index: number) => void;
  };
}> {
  questionAdded = () => {
    const answers = this.args.answers;
    quizAnswers(this.args.quiz.questions, answers.values, {});
    return answers;
  };
  <template>
    <div class="px-3 py-4 d-flex flex-column gap-4">
      {{#if (eq @view "input")}}
        <EditQuizInput @item={{@quiz}} @context={{@context}} />

        <EditQuizQuestionsInput
          @item={{@quiz}}
          @context={{@context}}
          @onQuestionAdded={{this.questionAdded}}
          @isolate={{@isolate}}
        />

        <EditQuizAvailability @item={{@quiz}} @context={{@context}} />
      {{else if (eq @view "output")}}
        <EditQuizOutput @item={{@quiz}} @context={{@context}} />

        {{#if (eq @quiz.templateOutput "certificate")}}
          <EditQuizCertificate @item={{@quiz}} @context={{@context}} />
        {{/if}}

        <EditQuizCategories @item={{@quiz}} @context={{@context}} />

        <EditQuizQuestionsOutput
          @item={{@quiz}}
          @context={{@context}}
          @onQuestionAdded={{this.questionAdded}}
        />

        <EditQuizTotals @item={{@quiz}} @context={{@context}} />

        <EditQuizReporting @item={{@quiz}} @context={{@context}} />

      {{/if}}
    </div>
  </template>
}
